module.exports = __webpack_public_path__ + "assets/icon-flag-component.88145060.svg";